<template>
  <svg class="icon" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_34_115)">
      <path d="M2.5 6.91658V6.91658C6.70966 2.9408 13.2903 2.9408 17.5 6.91658V6.91658" stroke-width="2" stroke-linecap="round"/>
      <path d="M5 9.83333V9.83333C7.6282 6.7671 12.3718 6.7671 15 9.83333V9.83333" stroke-width="2" stroke-linecap="round"/>
      <path d="M7.5 11.9167V11.9167C8.88071 10.536 11.1193 10.536 12.5 11.9167V11.9167" stroke-width="2" stroke-linecap="round"/>
      <path d="M10 15.75C9.58579 15.75 9.25 15.4142 9.25 15C9.25 14.5858 9.58579 14.25 10 14.25C10.4142 14.25 10.75 14.5858 10.75 15C10.75 15.4142 10.4142 15.75 10 15.75Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
  </svg>
</template>